module.exports = __webpack_public_path__ + "static/media/sopt10ru.e2819acc.pdf";